import React from 'react'
import PropTypes from 'prop-types'
// import Slider from "react-slick"
import NumberFormat from 'react-number-format';

// Atom
// import Button from './../../../../Components/Atoms/Button'

// Mol
// import PlayPlanCardMol from 'Components/Molecules/Cards/Plan/Play'
import General2PlanCardMol from './../../../../Components/Molecules/Cards/Plan/General2'
// import { useState } from 'react'
import Parser from 'html-react-parser';
import $ from 'jquery';
import { v4 as uuid } from 'uuid'

// sass, styles
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function Perfilador4PeopleOrg(props) {
    const {
        handleChangeCurrentPage,
        questionsAnswers,
        contenidoSel,
        planes,
        legales,
    } = props
    const contenido = contenidoSel ? contenidoSel?.map(c => {
        return `${c?.desc} ${c?.value}`
    }).join(', ') : ''
    // const [settingsSlider] = useState({
    //     responsive: [
    //         {
    //             breakpoint: 100000,
    //             settings: 'unslick'
    //         },
    //         {
    //             breakpoint: 960,
    //             settings: {
    //                 autoplay: false,
    //                 // autoplay: true,
    //                 autoplaySpeed: 7000,
    //                 speed: 600,
    //                 slidesToShow: 2,
    //                 slidesToScroll: 1,
    //                 dots: true,
    //                 arrows: false,
    //             }
    //         },
    //         {
    //             breakpoint: 480,
    //             settings: {
    //                 autoplay: false,
    //                 // autoplay: true,
    //                 autoplaySpeed: 7000,
    //                 speed: 600,
    //                 slidesToShow: 1,
    //                 slidesToScroll: 1,
    //                 dots: true,
    //                 arrows: false,
    //             }
    //         },

    //     ]

    // })
    function getQuestionInputValNum(tituloSearch = null) {
        let InputValNum = 1;
        if(questionsAnswers?.length){
            // const QuestionsAns = questionsAnswers.filter(function (Sectionquestions, index){
            //     return Sectionquestions.filter(ask => (ask.fi_TIPO === 3 && ask.fc_TITULO.indexOf(tituloSearch) ))?.length
            // });
            const QuestionsAns = questionsAnswers[1].filter(ask => (ask.fi_TIPO === 3 && ask.fc_TITULO.indexOf(tituloSearch) > -1 ));
            if (QuestionsAns?.length){
                let valNum = QuestionsAns[0]?.perfiladorRespuestas[0]?.InputValNum ? QuestionsAns[0]?.perfiladorRespuestas[0]?.InputValNum : 1
                InputValNum = valNum
                // console.log("questionsAnswers::::=>", tituloSearch, InputValNum, QuestionsAns)
            }
        }

        return InputValNum
    }
    let AmountPneracion = 0;
    let metrosHogar = "", numRepetidores = "No requiere"

    questionsAnswers?.map((Sectionquestions, index) => {
        let total = 0, totalask = 0, totalansw = 0
        console.log("Sectionquestions: ", Sectionquestions)

        Sectionquestions.map((ask, ind) => {
            if ( ask.fi_TIPO === 4 ){
                
                let list = ask.perfiladorRespuestas.filter(a => a.checked)
                let list2 = ask.perfiladorRespuestas.filter(a => a.checked)
                if (list?.length > 0){
                    list2.sort((a, b) => (a.fi_PONDERACION < b.fi_PONDERACION) ? 1 : -1)
                    list = list2
                    let ValNum =  getQuestionInputValNum(ask.fc_TITULO)
                    AmountPneracion += (list[0].fi_PONDERACION * ValNum)
                    
                    console.log("ask perfiladorRespuestas filter:", list)
                }
            }

            ask.perfiladorRespuestas.map((answ, keyansw) => {

            //     console.log("perfiladorRespuestas: ", answ, answ.fi_RESPUESTA, answ.fi_PONDERACION)

                if (ask.fi_TIPO === 1) {
                    if (ask?.IdAnswSelected === answ.fi_RESPUESTA) {
                        // totalansw += answ.fi_PONDERACION
                        // AmountPneracion += answ.fi_PONDERACION
                        metrosHogar = answ.fc_TITULO
                        // console.log("Select : ", AmountPneracion, answ)
                    }
                }

                // if (ask.fi_TIPO === 2 && answ.selected === true) {
                //     totalansw += answ.fi_PONDERACION
                //     AmountPneracion += answ.fi_PONDERACION
                //     console.log("Radio: ", AmountPneracion)
                // }

                // if (ask.fi_TIPO === 3 && answ?.InputValNum) {
                //     // totalansw += answ.fi_PONDERACION
                //     // AmountPneracion += answ.fi_PONDERACION
                //     console.log("Inpunt number: ", ask.fi_PREGUNTA, answ?.fi_RESPUESTA, answ?.InputValNum)
                // }

                // if (ask.fi_TIPO === 4 && answ.checked === true) {
                //     totalansw += answ.fi_PONDERACION
                //     AmountPneracion += answ.fi_PONDERACION
                //     console.log("checkbox fi_TIPO 4: ", AmountPneracion, answ)
                // }
                return totalansw
            })
            // totalask += totalansw
            // console.log("total Preguntas: ", totalask)
            return totalask
        })

        total += totalask
        
        if (metrosHogar === "Desde 80m² a 199m²"){
            numRepetidores = 2
        }else if(metrosHogar === "Desde 200m² a 300m²"){
            numRepetidores = 2
        }else if(metrosHogar === "Desde 301m² a 400m²"){
            numRepetidores = "3 a 4"
        }else if(metrosHogar === "Más de 401m²"){
            numRepetidores = 4
        }
        // AmountPneracion = 100
        console.log("total Sections Preguntas v2: ", totalansw, "metrosHogar:", metrosHogar, numRepetidores, AmountPneracion)
        return total
    })

    function getplanIdeal() {
        // const newPlanes = planes.filter(p => (p.fi_CATEGORIA === 1 || p.fi_CATEGORIA === 9 || p.fi_CATEGORIA === 10 || p.fi_CATEGORIA === 11 || p.fi_CATEGORIA === 12))
        const newPlanes = planes.filter(p => (p.fi_CATEGORIA === 9))
        // const newPlanes = planes.filter(p => p.fi_SERVICIO === 3 )
        let megasToFilter = 50
        if (AmountPneracion >= 56 && AmountPneracion <= 80){
            megasToFilter = 75
        }
        if (AmountPneracion >= 81 && AmountPneracion <= 105){
            megasToFilter = 100
        }
        if (AmountPneracion >= 105 && AmountPneracion <= 205){
            megasToFilter = 200
        }
        if (AmountPneracion >= 206 && AmountPneracion <= 505){
            megasToFilter = 500
        }
        if (AmountPneracion >= 505){
            megasToFilter = 1024
        }
        console.log("getplanIdeal aqui::::::: ", newPlanes, "AmountPneracion", AmountPneracion , "=>", megasToFilter)
        let planesIdeales = null //newPlanes?.find(p => p.megas_SUBIDA === megasToFilter)
        console.log("getplanIdeal aqui::::::: find ", planesIdeales)

        if (!planesIdeales) {
            planesIdeales = newPlanes.find(p => {
                // let Velocidad_descarga = p.caracteristicas.filter(c => (c.fc_TITULO.toUpperCase() === "VELOCIDAD DESCARGA" || c.fc_TITULO.toUpperCase() === "VELOCIDAD DE DESCARGA"))[0]?.fc_VALOR.toUpperCase()
                let Velocidad_descarga = p.fc_NOMBRE.toUpperCase()
                let text = " MBPS"
                // console.log("Velocidad_descarga: filter", Velocidad_descarga, p.fi_PLAN, Velocidad_descarga.search(text))
                if (Velocidad_descarga.search(text) === -1){
                    text = "GB"
                }

                let getMegas_SUBIDA = Velocidad_descarga.split(text)[0]
                // console.log("Velocidad_descarga: TEXT", text, getMegas_SUBIDA, Velocidad_descarga)
                if (getMegas_SUBIDA.search(" ")){
                    let ArrayGetMegas_SUBIDA = []
                    ArrayGetMegas_SUBIDA = Array.from(getMegas_SUBIDA.split(" "))
                    // console.log("Velocidad_descarga:", ArrayGetMegas_SUBIDA)
                    ArrayGetMegas_SUBIDA.map((element, index) =>{
                        if (parseInt(element)){
                            getMegas_SUBIDA = parseInt(element)
                            if ( text === "GB" ){
                                getMegas_SUBIDA = parseInt(element) * 1024
                            }
                        }
                        return element
                    })
                }
                // console.log("Velocidad_descarga:", text, "getMegas_SUBIDA: ", getMegas_SUBIDA)
                p.caracteristicas.map((caract, index)=>{
                    caract.megas_SUBIDA = getMegas_SUBIDA;
                    return caract
                })
                return p.caracteristicas.find(c => c.megas_SUBIDA === megasToFilter)
            })
            console.log("getplanIdeal aqui::::::: find caracteristicas ", planesIdeales)
        }
        if (!planesIdeales) {
            const maximum = Math.max(...newPlanes.map((i) => i.megas_SUBIDA));
            planesIdeales = newPlanes?.find(p => p.megas_SUBIDA >= maximum)
            if (!planesIdeales) {
                planesIdeales = newPlanes.find(p => {
                    return p.caracteristicas.find(c => c.megas_SUBIDA >= maximum)
                })
            }
        }
        let returnPlans =[]
        if(planesIdeales){
            returnPlans[0] = planesIdeales
        }
        console.log("planesIdeales:", returnPlans, "AmountPneracion:", AmountPneracion)
        return returnPlans
    }
    
    function replaceEm(){
        let em = $(".ico-plus");
        let i = '<i class="ico-plus"></i>';
        console.log("replaceEm", em);
        if (em){
            em.first().after(i);
            em.remove()
        }
    }
    function replaceText(){
        if (numRepetidores !== "No requiere"){
            let p = $(".perfiladorFinalAdd").find("p:first").text();
            // $(content).find("p:first").text()
            console.log("p first-child:=>", p)
            if (p){
                let text = p
                if ( numRepetidores !== "3 a 4"){
                    text = p.replace("de 1 a 3", numRepetidores)
                }else{
                    text = p.replace("1 a 3", numRepetidores)
                }
                $(".perfiladorFinalAdd").find("p:first").text(text);
            }
            // console.log("p first-child:", p.innerHTML)
        }
    }
    
    const planIdeal = getplanIdeal();
    const PlayPLanData = planIdeal.length ? planIdeal.map((item, index) => (
        <General2PlanCardMol
            key={uuid()}
            title={item?.fc_TEXTO_CAJA}
            titlestyle={item?.fc_COLOR_CAJA ? item?.fc_COLOR_CAJA.toLowerCase() : null}
            name={item?.fc_NOMBRE}
            fi_PLAN={item?.fi_PLAN}
            fi_ID_TELEFONIA={item?.fi_ID_TELEFONIA}
            fi_ID_TELEVISION={item?.fi_ID_TELEVISION}
            fi_ID_INTERNET={item?.fi_ID_INTERNET}
            fi_CATEGORIA={item?.fi_CATEGORIA}
            fc_TIPO_DISPONIBILIDAD={item?.fc_TIPO_DISPONIBILIDAD}
            fc_TEXTO_CAJA={item?.fc_TEXTO_CAJA}
            fc_COLOR_CAJA={item?.fc_COLOR_CAJA}
            fc_NOMBRE={item?.fc_NOMBRE}
            fc_DESCRIPCION={item?.fc_DESCRIPCION}
            fi_NUMERO_CARACTERISTICAS_MOSTRAR={item?.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
            fc_TITULO_CARACTERISTICAS_AGRUPADAS={item?.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
            fi_PRECIO_PLAN={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(item?.fi_PRECIO_PLAN) ? item?.fi_PRECIO_PLAN + ".00" : item?.fi_PRECIO_PLAN.toFixed(2)} />}
            fi_PRECIO_TELEFONIA_ENPS={item?.fi_PRECIO_TELEFONIA_ENPS}
            fi_PRECIO_TELEVISION_ESPN={item?.fi_PRECIO_TELEVISION_ESPN}
            fi_PRECIO_INTERNET_ESPS={item?.fi_PRECIO_INTERNET_ESPS}
            fc_COLOR_PRECIO={item?.fc_COLOR_PRECIO}
            fc_ETIQUETA_PRECIO_TACHADO={item?.fc_ETIQUETA_PRECIO_TACHADO}
            fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={item?.fc_PRECIO_TACHADO.includes(".") ? item?.fc_PRECIO_TACHADO : item?.fc_PRECIO_TACHADO + ".00"} />}
            Discount={item?.fc_PRECIO_TACHADO > 0 && parseInt(item?.fc_PRECIO_TACHADO) !== parseInt(item?.fi_PRECIO_PLAN) ? <NumberFormat displayType={'text'} value={(100 - (item?.fi_PRECIO_PLAN * 100) / item?.fc_PRECIO_TACHADO).toFixed(0)} /> : null}
            fc_NOTA_DEBAJO_PRECIO={item?.fc_NOTA_DEBAJO_PRECIO}
            fc_TEXTO_DETALLE={item?.fc_TEXTO_DETALLE}
            fc_URL_DETALLE={item?.fc_URL_DETALLE}
            fc_TARGET_DETALLE={item?.fc_TARGET_DETALLE}
            fi_BAN_DETALLE={item?.fi_BAN_DETALLE}
            fc_OPCION_CONTRATACION={item?.fc_OPCION_CONTRATACION}
            fc_TEXTO_CONTRATAR={item?.fc_TEXTO_CONTRATAR}
            fc_URL_CONTRATAR={item?.fc_URL_CONTRATAR}
            fc_TARGET_CONTRATAR={item?.fc_TARGET_CONTRATAR}
            fi_BAN_CONTRATAR={item?.fi_BAN_CONTRATAR}
            fi_ORDEN={item?.fi_ORDEN}
            fi_ACTIVO={item?.fi_ACTIVO}
            fi_ID_DASHBOARD={item?.fi_ID_DASHBOARD}
            fi_BAN_ENPN={item?.fi_BAN_ENPN}
            fi_BAN_ENPS={item?.fi_BAN_ENPS}
            fi_BAN_ESPN={item?.fi_BAN_ESPN}
            fi_BAN_ESPS={item?.fi_BAN_ESPS}
            fc_ETIQUETA_PROMOCION_ATP={item?.fc_ETIQUETA_PROMOCION_ATP}
            fi_PRECIO_AHORRO={item?.fi_PRECIO_AHORRO}
            fc_ETIQUETA_PERIODO={item?.fc_ETIQUETA_PERIODO}
            fc_TITULO_PROMO={item?.fc_TITULO_PROMO}
            Caracteristicas={item?.caracteristicas}
            caracteristicasPromocion={item?.caracteristicasPromocion}
            Acordeon={item?.acordeon}
            lstPlanContratacionxPlan={item?.lstPlanContratacionxPlan}
            fi_INCLUIR_SECCION={item?.fi_INCLUIR_SECCION}
            fc_ETIQUETA_ROJA={item?.fc_ETIQUETA_ROJA}
            fc_TITULO_SECCION={item?.fc_TITULO_SECCION}
            fc_DESCRIPCION_SECCION={item?.fc_DESCRIPCION_SECCION}
            fc_TEXTO_BOTON={item?.fc_TEXTO_BOTON}
            fc_TARGET_BOTON={item?.fc_TARGET_BOTON}
            fc_URL_BOTON={item?.fc_URL_BOTON}
            fc_DESCRIPCION_OFERTA={item?.fc_DESCRIPCION_OFERTA}
            fc_PLAN_ICONO={item?.fc_PLAN_ICONO}
            fi_SERVICIO={item?.fi_SERVICIO}
            
        />
    )) :null
    const LegalLEP = legales.find(l => l.fc_BLOQUE === "LEP")
    const LegalREC = legales.find(l => l.fc_BLOQUE === "REC")
    const LegalLEG = legales.find(l => l.fc_BLOQUE === "LEG")
    if (LegalREC?.fc_HTML_AVANZADO){
        $(document).ready(function(){
            replaceEm()
            replaceText()
        })
    }
    console.log("contenido", contenido)
    return (
        <section className="light">
            <div className="container">
                <div className="perfiladorTitle">
                    <h2>¡Gracias por tus respuestas!</h2>
                    <p>De acuerdo a tus necesidades te recomendamos el plan:</p>
                    {/* <p>{contenido}</p> */}
                    {/* <p>2 pisos, 3 dispositivos, 3 Habitaciones</p> */}
                    {/* <p className='perfiladorTitleRel'>Encontramos el Plan ideal para ti</p> */}
                </div>
                <div className="perfiladorFinal">
                    <div className='perfiladorFinalWrap'>
                        {
                            PlayPLanData
                        }
                        {/* <General2PlanCardMol
                            title={planIdeal?.fc_TEXTO_CAJA}
                            titlestyle={planIdeal?.fc_COLOR_CAJA ? planIdeal?.fc_COLOR_CAJA.toLowerCase() : null}
                            name={planIdeal?.fc_NOMBRE}
                            fi_PLAN={planIdeal?.fi_PLAN}
                            fc_DESCRIPCION={planIdeal?.fc_DESCRIPCION}
                            fi_NUMERO_CARACTERISTICAS_MOSTRAR={planIdeal?.fi_NUMERO_CARACTERISTICAS_MOSTRAR}
                            fc_TITULO_CARACTERISTICAS_AGRUPADAS={planIdeal?.fc_TITULO_CARACTERISTICAS_AGRUPADAS}
                            fi_PRECIO_PLAN={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={Number.isInteger(planIdeal?.fi_PRECIO_PLAN) ? planIdeal?.fi_PRECIO_PLAN + ".00" : planIdeal?.fi_PRECIO_PLAN} />}
                            fc_COLOR_PRECIO={planIdeal?.fc_COLOR_PRECIO}
                            fc_ETIQUETA_PRECIO_TACHADO={planIdeal?.fc_ETIQUETA_PRECIO_TACHADO}
                            fc_PRECIO_TACHADO={<NumberFormat thousandSeparator={","} decimalSeparator={"."} displayType={'text'} value={planIdeal?.fc_PRECIO_TACHADO.includes(".") ? planIdeal?.fc_PRECIO_TACHADO : planIdeal?.fc_PRECIO_TACHADO + ".00"} />}
                            Discount={planIdeal?.fc_PRECIO_TACHADO > 0 && parseInt(planIdeal?.fc_PRECIO_TACHADO) !== parseInt(planIdeal?.fi_PRECIO_PLAN) ? <NumberFormat displayType={'text'} value={(100 - (planIdeal?.fi_PRECIO_PLAN * 100) / planIdeal?.fc_PRECIO_TACHADO).toFixed(0)} /> : null}
                            fc_NOTA_DEBAJO_PRECIO={planIdeal?.fc_NOTA_DEBAJO_PRECIO}
                            fc_TEXTO_DETALLE={planIdeal?.fc_TEXTO_DETALLE}
                            fc_URL_DETALLE={planIdeal?.fc_URL_DETALLE}
                            fc_TARGET_DETALLE={planIdeal?.fc_TARGET_DETALLE}
                            fc_OPCION_CONTRATACION={planIdeal?.fc_OPCION_CONTRATACION}
                            fc_TEXTO_CONTRATAR={planIdeal?.fc_TEXTO_CONTRATAR}
                            fc_URL_CONTRATAR={planIdeal?.fc_URL_CONTRATAR}
                            fc_TARGET_CONTRATAR={planIdeal?.fc_TARGET_CONTRATAR}
                            fc_ETIQUETA_PERIODO={planIdeal?.fc_ETIQUETA_PERIODO}
                            Caracteristicas={planIdeal?.caracteristicas}
                            Acordeon={planIdeal?.acordeon}
                            lstPlanContratacionxPlan={planIdeal?.lstPlanContratacionxPlan}
                        /> */}
                    </div>
                    {
                        LegalLEP
                            ?
                            LegalLEP?.fc_HTML_AVANZADO ? Parser(LegalLEP?.fc_HTML_AVANZADO) : null
                            : null
                    }
                    {/* <div className="perfiladorFinalAdd"> */}
                        {
                            LegalREC && numRepetidores!=="No requiere"
                                ?
                                LegalREC?.fc_HTML_AVANZADO ? Parser(LegalREC?.fc_HTML_AVANZADO) : null
                                : null
                        }
                    {/* </div> */}

                    {
                        LegalLEG
                            ?
                            LegalLEG?.fc_HTML_AVANZADO ? Parser(LegalLEG?.fc_HTML_AVANZADO) : null
                            : null
                    }
                </div>
                <div className="perfiladorBtns perfBtn04">
                    <button className='btn btnPrimario' type='button' value='Perfilador1Org' onClick={(e) => { handleChangeCurrentPage(e, null, 'init') }}>
                        Volver a calcular
                    </button>
                </div>
            </div>
        </section>
    )
}
Perfilador4PeopleOrg.dafaultProps = {
    items: [{}, {}, {}]
}
Perfilador4PeopleOrg.propTypes = {
    items: PropTypes.array
}
export default Perfilador4PeopleOrg
